export function handleCorruptedLocalStorage() {
  try {
    const keysToCheck = ['access_token', 'refresh_token', 'user'];

    for (const key of keysToCheck) {
      const raw = localStorage.getItem(key);
      if (raw === null || raw === "undefined" || raw === "") continue;

      // Solo intentamos parsear si creemos que es un objeto (por heurística simple)
      const isProbablyJson = raw.trim().startsWith("{") || raw.trim().startsWith("[");
      if (isProbablyJson) {
        JSON.parse(raw); // ← solo si es JSON probable
      }
    }
  } catch (e) {
    console.warn("Datos corruptos detectados en localStorage. Limpiando...");
    localStorage.clear();
    (window.location as Location).reload();
  }

  window.addEventListener("error", (e) => {
    if (
      e.message.includes("Unexpected token") &&
      e.filename?.includes("localStorage")
    ) {
      console.warn("Error global de JSON.parse detectado. Limpiando localStorage...");
      localStorage.clear();
      (window.location as Location).reload();
    }
  });
}
